import getProcessedRichtext from "components/Paragraph/helpers/getProcessedRichtext";
import Paragraph from "components/Paragraph/Paragraph";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent, useEffect, useState, createRef } from "react";
import styles from "./Accordion.module.scss";
import AccordionProps from "./AccordionProps.interface";

const Accordion: FunctionComponent<AccordionProps> = (props) => {
    const content = createRef<HTMLDivElement>();

    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState("0px");

    const isOpenClass = isOpen ? styles.is_open : undefined;

    useEffect(() => {
        if (content.current) {
            setHeight(!isOpen ? "0px" : `${content.current.scrollHeight}px`);
        }
    }, [isOpen, content]);

    return (
        <div className={combineClasses(styles.wrapper, isOpenClass)}>
            {/* Heading */}
            <button className={styles.header_button} onClick={() => setIsOpen(!isOpen)}>
                <h3 className={styles.heading}>{props.content.heading}</h3>

                <span className={styles.indicator}>
                    <span className={styles.indicator_line} />
                    <span className={styles.indicator_line} />
                </span>
            </button>

            {/* Content */}
            <div className={styles.content} ref={content} style={{ maxHeight: `${height}` }}>
                {props.content.bodyText ? (
                    <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                ) : null}
            </div>
        </div>
    );
};

export default Accordion;
